<smt-search-select [group]="form" [controlName]="'select'" [canClean]="false" [showTooltip]="true"
    [options]="options" (optionSelected)="updateQuery()" (removedValue)="updateQuery()" [disabled]="!editable"></smt-search-select>